import React from 'react';

const QuoteBuilderLayout = ({ drawing, children }) => {
  return (
    <div className="card" style={{ margin: '10px' }} data-widget-element="layout-container">
      <div className="row">
        <div className="col-6" data-widget-element="image-column">
          <div style={{ margin: '20px' }}>
            {drawing.image !== undefined && (
              <img
                src={drawing.image.three_d_image_url}
                width="200"
                alt="3D Preview"
                data-widget-element="preview-image"
              />
            )}
          </div>
        </div>
        <div className="col-5" data-widget-element="form-column">
          <br />
          <h3 style={{ textAlign: 'center' }} data-widget-element="title">{t('quote_builder_widget.get_a_quote')}</h3>
          <br />
          <div data-widget-element="form-section">
            {children}
          </div>
        </div>
      </div>
    </div>
  );
};

export default QuoteBuilderLayout;
